import React, { useEffect, useState } from 'react';
import { adminAPI } from '../services/api';
import { RefreshCw } from 'lucide-react';

export function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const r = await adminAPI.logs(300); setLogs(r.data); } catch (e) { alert('Could not load the activity log'); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div style={s.header}>
        <h1 style={s.title}>Activity Log</h1>
        <button style={s.outlineBtn} onClick={load}><RefreshCw size={14} /> Refresh</button>
      </div>
      <div style={s.panel}>
        {loading ? <div style={s.empty}>Loading...</div> :
         logs.length === 0 ? <div style={s.empty}>No activity yet</div> :
         logs.map(l => (
          <div key={l.id} style={s.logEntry}>
            <div style={s.logTime}>{(l.created_at || '').replace('T', ' ').slice(0, 19)}</div>
            <div style={s.logAction}>{l.action.replace(/_/g, ' ')}</div>
            <div style={s.logDetail}>{l.details || '—'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Pricing() {
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({ name: '', box_size: 'S', duration_minutes: 60, price: 2, currency: 'GEL' });

  const load = async () => { try { const r = await adminAPI.pricing(); setPlans(r.data); } catch (e) {} };
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await adminAPI.createPricing(form); load(); setForm({ name: '', box_size: 'S', duration_minutes: 60, price: 2, currency: 'GEL' }); }
    catch (e) { alert(e.response?.data?.detail || 'Error'); }
  };

  return (
    <div>
      <h1 style={s.title}>Pricing Plans</h1>
      <div style={{ ...s.panel, padding: 20, marginTop: 20, marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div><label style={s.label}>Name</label><input style={s.input} value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="e.g. Small 1hr" /></div>
          <div><label style={s.label}>Size</label><select style={s.input} value={form.box_size} onChange={e => setForm({...form, box_size: e.target.value})}><option value="S">S</option><option value="M">M</option><option value="L">L</option></select></div>
          <div><label style={s.label}>Duration (min)</label><input style={s.input} type="number" value={form.duration_minutes} onChange={e => setForm({...form, duration_minutes: parseInt(e.target.value)})} /></div>
          <div><label style={s.label}>Price</label><input style={s.input} type="number" step="0.5" value={form.price} onChange={e => setForm({...form, price: parseFloat(e.target.value)})} /></div>
          <div><label style={s.label}>Currency</label><input style={s.input} value={form.currency} onChange={e => setForm({...form, currency: e.target.value})} style={{...s.input, width: 70}} /></div>
          <button style={s.primaryBtn} onClick={create}>Add Plan</button>
        </div>
      </div>
      <div style={s.panel}>
        <table style={s.table}>
          <thead><tr><th style={s.th}>Name</th><th style={s.th}>Size</th><th style={s.th}>Duration</th><th style={s.th}>Price</th><th style={s.th}>Actions</th></tr></thead>
          <tbody>
            {plans.map(p => (
              <tr key={p.id}>
                <td style={s.td}>{p.name}</td><td style={s.td}>{p.box_size}</td>
                <td style={s.td}>{p.duration_minutes} min</td><td style={s.td}>{p.price} {p.currency}</td>
                <td style={s.td}><button style={{...s.smBtn, color:'#ff4466', borderColor:'rgba(255,68,102,0.3)'}} onClick={async()=>{await adminAPI.deletePricing(p.id);load();}}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function Users() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const load = async () => { try { const r = await adminAPI.users(); setUsers(r.data); } catch (e) {} };
  useEffect(() => { load(); }, []);
  const toggleRole = async (id, current) => {
    const newRole = current === 'admin' ? 'customer' : 'admin';
    await adminAPI.setUserRole(id, newRole); load();
  };
  const handleDelete = async (u) => {
    if (!window.confirm('Delete user ' + u.email + '? This will also delete their orders.')) return;
    try { await adminAPI.deleteUser(u.id); load(); } catch (e) { alert(e.response?.data?.detail || 'Error'); }
  };
  const filtered = users.filter(u => {
    const q = search.toLowerCase();
    return !q || (u.full_name||'').toLowerCase().includes(q) || (u.first_name||'').toLowerCase().includes(q) || (u.last_name||'').toLowerCase().includes(q) || u.email.toLowerCase().includes(q) || (u.phone||'').includes(q) || (u.id_number||'').includes(q);
  });
  return (
    <div>
      <div style={s.header}>
        <h1 style={s.title}>Users ({users.length})</h1>
        <div style={{display:'flex',gap:10,alignItems:'center'}}>
          <input style={{...s.input,width:240}} placeholder="Search name, email, phone, ID..." value={search} onChange={e=>setSearch(e.target.value)} />
          <button style={s.outlineBtn} onClick={load}><RefreshCw size={14} /> Refresh</button>
        </div>
      </div>
      <div style={{ ...s.panel, marginTop: 20, overflowX:'auto' }}>
        <table style={s.table}>
          <thead><tr>
            <th style={s.th}>Name</th><th style={s.th}>Email</th><th style={s.th}>Phone</th>
            <th style={s.th}>ID Number</th><th style={s.th}>Role</th><th style={s.th}>Status</th>
            <th style={s.th}>Registered</th><th style={s.th}>Actions</th>
          </tr></thead>
          <tbody>
            {filtered.map(u => (
              <tr key={u.id}>
                <td style={s.td}>{u.first_name || u.last_name ? (u.first_name||'') + ' ' + (u.last_name||'') : u.full_name || '\u2014'}</td>
                <td style={s.td}>{u.email}</td>
                <td style={s.td}>{u.phone || '\u2014'}</td>
                <td style={s.td}><span style={{fontFamily:"'Space Mono',monospace",fontSize:12}}>{u.id_number || '\u2014'}</span></td>
                <td style={s.td}><span style={{...s.badge, background: u.role === 'admin' ? 'rgba(167,139,250,0.1)' : u.role === 'staff' ? 'rgba(255,176,32,0.1)' : 'rgba(77,144,254,0.1)', color: u.role === 'admin' ? '#a78bfa' : u.role === 'staff' ? '#ffb020' : '#4d90fe'}}>{u.role}</span></td>
                <td style={s.td}>{u.is_active ? <span style={{color:'#8BC63E'}}>Active</span> : <span style={{color:'#ff4466'}}>Disabled</span>}</td>
                <td style={s.td}><span style={{fontSize:12,color:'#8789a0'}}>{new Date(u.created_at).toLocaleDateString('ka-GE', {timeZone: 'Asia/Tbilisi'})}</span></td>
                <td style={s.td}>
                  <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                    <button style={s.smBtn} onClick={() => toggleRole(u.id, u.role)}>Role</button>
                    <button style={s.smBtn} onClick={async()=>{await adminAPI.toggleUser(u.id);load();}}>{u.is_active ? 'Disable' : 'Enable'}</button>
                    {u.role !== 'admin' && <button style={{...s.smBtn, color:'#ff4466', borderColor:'rgba(255,68,102,0.3)'}} onClick={()=>handleDelete(u)}>Delete</button>}
                  </div>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={8} style={{...s.td,textAlign:'center',color:'#565870'}}>No users found</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export function Settings() {
  return (
    <div>
      <h1 style={s.title}>Settings</h1>
      <div style={{ ...s.panel, padding: 24, marginTop: 20 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#e4e5ed', marginBottom: 8 }}>API Configuration</h3>
        <p style={{ fontSize: 13, color: '#8789a0', marginBottom: 16 }}>Your Bestwond API credentials are stored securely in the server environment file at <code style={{ background: '#161821', padding: '2px 6px', borderRadius: 4, fontSize: 12 }}>/opt/lockerhq/backend/.env</code></p>
        <div style={{ background: '#0a0b0e', borderRadius: 8, padding: 16, fontFamily: "'Space Mono', monospace", fontSize: 12, color: '#565870', lineHeight: 1.8 }}>
          BW_API_URL=https://api.bestwond.com<br/>
          BW_APP_ID=bw_d714287823d611f<br/>
          BW_APP_SECRET=●●●●●●●●●●●●●●●●<br/>
        </div>
      </div>
      <div style={{ ...s.panel, padding: 24, marginTop: 16 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#e4e5ed', marginBottom: 8 }}>Platform Info</h3>
        <div style={{ fontSize: 13, color: '#8789a0', lineHeight: 2 }}>
          Backend: FastAPI + PostgreSQL<br/>
          Frontend: React<br/>
          Locker API: Bestwond Cabinet API v3<br/>
          Server: Ubuntu 24.04 LTS<br/>
        </div>
      </div>
    </div>
  );
}

const s = {
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 },
  title: { fontSize: 22, fontWeight: 700, color: '#e4e5ed', marginBottom: 0 },
  panel: { background: '#0f1117', border: '1px solid #252733', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8, color: '#565870', background: '#0a0b0e', borderBottom: '1px solid #252733' },
  td: { padding: '12px 16px', fontSize: 13, borderBottom: '1px solid #1a1b25', color: '#e4e5ed' },
  badge: { display: 'inline-flex', padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600 },
  smBtn: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 10px', background: 'transparent', border: '1px solid #252733', borderRadius: 6, color: '#8789a0', fontSize: 11, fontWeight: 500, cursor: 'pointer' },
  primaryBtn: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '9px 18px', background: '#8BC63E', border: 'none', borderRadius: 8, color: '#07080c', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
  outlineBtn: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 16px', background: 'transparent', border: '1px solid #252733', borderRadius: 8, color: '#8789a0', fontSize: 12, fontWeight: 500, cursor: 'pointer' },
  label: { display: 'block', fontSize: 11, fontWeight: 600, color: '#8789a0', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 },
  input: { background: '#161821', border: '1px solid #252733', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: '#e4e5ed', outline: 'none', boxSizing: 'border-box' },
  logEntry: { display: 'flex', gap: 16, padding: '11px 20px', borderBottom: '1px solid #1a1b25', alignItems: 'center' },
  logTime: { fontFamily: "'Space Mono', monospace", fontSize: 11, color: '#565870', whiteSpace: 'nowrap', minWidth: 150 },
  logAction: { fontSize: 12, fontWeight: 600, color: '#8BC63E', textTransform: 'capitalize', minWidth: 120 },
  logDetail: { fontSize: 13, color: '#8789a0', flex: 1 },
  empty: { padding: 40, textAlign: 'center', color: '#565870', fontSize: 13 },
};

